export default __webpack_public_path__ + "static/media/particula.e4beb222.png";